import ToViewIcon from './component'

export default ToViewIcon
